// Client error reporting contract (browser → reportClientError callable → Slack).
// Deliberately import-free: both frontends pull ClientErrorApp in as a runtime value, and
// types.ts imports firebase-admin — keeping these here means no backend package can ever be
// dragged into a frontend bundle through this module.

export type ClientErrorSeverity = 'error' | 'critical'

// Which frontend produced the error. Server renders only these known values.
export enum ClientErrorApp {
  WEB_EVOLVE = 'transition-web-evolve',
  BACK_OFFICE = 'intraction-bo'
}

// Callable on purpose instead of a Slack webhook: the browser must never hold a Slack
// credential, and the server picks the channel, not the client.
export type ReportClientErrorRequest = {
  app: ClientErrorApp
  severity: ClientErrorSeverity
  name: string
  message: string
  stack?: string
  context?: string
  url?: string
  // Only trusted when the caller is unauthenticated (e.g. a failing login) — rendered as unverified.
  userEmail?: string
  userId?: string
}

export type ReportClientErrorResponse = {
  delivered: boolean
  reason?: 'rate-limited' | 'duplicate'
}
